import React from 'react'

export default function LoadingSurvey() {
  return (
    <div className='flex flex-col items-center justify-center gap-5'>
      <div className='relative h-2 w-52 rounded-full bg-pop-baby-blue' role='progressbar'>
        <div className='animate-progress absolute h-2 rounded-full bg-pop-dodger-blue' />
      </div>
      <span className='text-sm font-normal text-black'>Loading Survey</span>
    </div>
  )
}
